module.exports = __webpack_public_path__ + "img/difficultyLevel_4_gray.d1019041.svg";